import { Link } from 'react-router-dom'
import { PublicNavBar } from '../components/PublicNavBar'
import { PublicFooter } from '../components/PublicFooter'
import { usePageMeta } from '../hooks/usePageMeta'

const LINKS = [
  { to: '/', label: 'Home', blurb: 'Describe a feature and watch parallel AI coding agents ship it.' },
  { to: '/products', label: 'Features', blurb: 'Agent swarm, AI code review, PRD execution, and pipelines.' },
  { to: '/estimate', label: 'Idea Estimator', blurb: 'Free AI project estimate — no signup required.' },
  { to: '/pricing', label: 'Pricing', blurb: 'Free forever, Pro at $19/mo, Team at $49/seat/mo.' },
  { to: '/blog', label: 'Blog', blurb: 'Engineering notes on running AI agents in parallel.' },
  { to: '/packages', label: 'Packages', blurb: 'factory-cli and factory-mcp downloads.' },
]

// Rendered for unknown in-app paths, and prerendered to dist/404.html which the
// web server returns (with a real 404 status) for unknown URLs. Deliberately
// noindex — a 404 body must never be indexed under the URL that produced it.
export default function NotFound() {
  usePageMeta({
    title: 'Page Not Found — Factory Nexus',
    description: 'That page does not exist. Find Factory Nexus features, pricing, the free idea estimator, and the blog.',
    path: '/404',
    robots: 'noindex, follow',
  })

  return (
    <div className="min-h-screen flex flex-col text-gray-900 dark:text-gray-100">
      <PublicNavBar />

      <main className="flex-1 px-4 py-20 sm:py-28">
        <div className="max-w-3xl mx-auto">
          <p className="text-sm font-semibold text-primary-600 dark:text-primary-400 uppercase tracking-wider mb-3">
            404
          </p>
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">Page not found</h1>
          <p className="text-gray-500 dark:text-gray-400 mb-10">
            The page you asked for doesn&apos;t exist — it may have moved or never existed. Here&apos;s where
            everything lives:
          </p>

          <ul className="grid sm:grid-cols-2 gap-4">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="block h-full p-4 rounded-xl border border-gray-200 dark:border-gray-700 hover:border-primary-400 transition-colors"
                >
                  <span className="font-medium text-primary-600 dark:text-primary-400">{l.label}</span>
                  <span className="block text-sm text-gray-500 dark:text-gray-400 mt-1">{l.blurb}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </main>

      <PublicFooter />
    </div>
  )
}
